import { Button } from '@99designs/common/components/Button';
import React from 'react';

interface Props {
    userId: number;
    isDisabled?: boolean;
}

const UserInviteButton = ({ isDisabled = false, userId }: Props) => (
    <Button
        variations={['primary', 'fluid', 'jumbo']}
        href={!isDisabled ? `/profiles/${userId}/invites` : null}
        isDisabled={isDisabled}
    >
        {isDisabled ? __('Not available for work') : __('Invite to work')}
    </Button>
);

export default UserInviteButton;



// WEBPACK FOOTER //
// ./src/js/components/UserInviteButton.tsx